import { TvaService } from 'src/app/shared/services/simple/tva.service';
import { TvaModel } from './../../../shared/models/simple-types/tva.model';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { ModalAddCategorieComponent } from 'src/app/shared/components/modals/modal-add-categorie/modal-add-categorie.component';

@Component({
  selector: 'app-gestion-categorie',
  templateUrl: './gestion-categorie.component.html',
  styleUrls: ['./gestion-categorie.component.scss']
})
export class GestionCategorieComponent {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: CategorieModel;
  displayedColumns: string[] = ['code', 'libelle', 'codeNa', 'codeTva', 'action'];
  dataSource: CategorieModel[];
  matDataSource = new MatTableDataSource<CategorieModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  categories: CategorieModel[] = [];
  tvas: TvaModel[] = [];
  nas: NaModel[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private comp: TrieTabService,
    injector: Injector,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private categorieService: CategorieService,
    private naService: NaService,
    private tvaService: TvaService,
    private societeService: SocieteService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService
  )
  {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.toastrService.error('Erreur durant la récupération de la categorie.', 'Erreur');
        this.router.navigate(['/']);
      } else {
        this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
          if (societe) {
           this.societe = societe;
           this.objet.query = '';
           this.objet.pageNumber = 0;
           this.objet.pageSize = this.pageSize;
           this.objet.order = 'libelle';
           this.matDataSource.paginator = this.paginator;
           this.loadPage();
           // getAll cgCharge societe 1
           this.naService.getAll().subscribe(nas => {
              this.nas = nas;
            });
            // getAll typeComp
           this.tvaService.getAll().subscribe(tvas => {
              this.tvas = tvas;
            });
          }
        });
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function() {
       return false;
     };
    this.mySubscription = this.router.events.subscribe((event) => {
       if (event instanceof NavigationEnd) {
         this.router.navigated = false;
       }
     });
  }

  getNaByCode(code: string): string{
    const na = this.nas.find(n => n.code === code);
    if (na) {
      return na.code + '-' + na.libelle;
    } else {
      return '';
    }
  }

  getTvaByCode(code: string): string{
    const tva = this.tvas.find(t => t.code === code);
    if (tva) {
      return tva.code + '-' + tva.libelle;
    } else {
      return '';
    }
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateCategorieFormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddCategorieComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          categories: this.categories,
          nas: this.nas,
          tvas: this.tvas,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });

  }

  onModify(categorie: CategorieModel): void {
    const form = this.gestionReferentielComponent.getEditCategorieFormGroup(categorie);
    const dialogRef = this.dialog.open(ModalAddCategorieComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          categories: this.categories,
          nas: this.nas,
          tvas: this.tvas,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });
  }


  onDelete(categorie: CategorieModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression de la categorie',
        message: 'Êtes-vous sur de vouloir supprimer la categorie ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.categorieService.delete(categorie.id).subscribe((response: CategorieModel) => {
          this.toastrService.success('La catégorie a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(categories: CategorieModel[]): CategorieModel[] {
    categories = categories.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return categories;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.categorieService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<CategorieModel>) => {
      if (query.objets != null) {
        this.categories = query.objets;
      } else {
        this.categories = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<CategorieModel>(this.categories);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}
